import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchLoyaltyAccountFailure,
  fetchLoyaltyAccountSuccess,
  fetchLoyaltyLinkWebviewFailure,
  fetchLoyaltyLinkWebviewSuccess,
} from "./actions";
import { FETCH_LOYALTY_ACCOUNT_REQUEST, FETCH_LINK_WEBVIEW_LOYALTY_REQUEST } from "./actions.type";

import { fetchLoyaltyAccountService, fetchLoyaltyWebviewService } from "../services/loyalty.service";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { hideModal, showModal } from "app/modules/modal-management/reducer/action";

function* fetchLoyaltyAccountSaga() {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchLoyaltyAccountService);
    console.log("Loyalty info response: ", response);
    if (response.status === 200) {
      yield put(fetchLoyaltyAccountSuccess(response.data.RESPONSEDATA?.LOYALTY_ACCOUNT));
    }
  } catch (e: any | AxiosError) {
    yield put(fetchLoyaltyAccountFailure());
  }
}

function* fetchLoyaltyLinkWebviewSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchLoyaltyWebviewService);
    console.log("Loyalty LinkWebview response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchLoyaltyLinkWebviewSuccess(response.data?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchLoyaltyLinkWebviewFailure());
  }
}

function* loyaltySaga() {
  yield all([
    takeLatest(FETCH_LOYALTY_ACCOUNT_REQUEST, fetchLoyaltyAccountSaga),
    takeLatest(FETCH_LINK_WEBVIEW_LOYALTY_REQUEST, fetchLoyaltyLinkWebviewSaga),
  ]);
}

export default loyaltySaga;
